export default __webpack_public_path__ + "static/media/Button-Quests.113295a3.svg";